import { jsx } from "react/jsx-runtime";
const MedicineWarning = ({ isHovered }) => {
  const normal = /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "M30.915 30.34h.411a.318.318 0 00.318-.317v-4.647a.317.317 0 00-.318-.317h-.41a.316.316 0 00-.318.317v4.647c0 .174.142.317.317.317zm-8.06 4.821l8.21-14.942 8.314 14.942H22.855zm3.623 3.522h-14.89V32.56h7.411V20.861h-7.412v-.734c0-4.105 3.34-7.445 7.445-7.445 4.107 0 7.446 3.34 7.446 7.445v5.74l-5.82 10.595h5.82v2.221zm-14.89-7.124h6.411v-9.698h-6.412v9.698zm10.268-20.877v1.176a8.69 8.69 0 00-2.824-.477c-.989 0-1.936.173-2.824.477v-1.176h5.648zm-6.754-1.3h7.862V7.518h-7.862v1.862zm15.956 8.15l-3.279 5.967v-3.372c0-3.33-1.874-6.232-4.622-7.709v-1.736h1.108V6.218H13.801v4.464h1.106v1.737c-2.747 1.477-4.62 4.377-4.62 7.708v19.857h17.492v-3.522H41.59l-10.532-18.93zm.063 14.03a.816.816 0 10.001 1.633.816.816 0 000-1.633z"
    }
  );
  const normalHover = /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      d: "M33.048 30.914a.941.941 0 100 1.883.941.941 0 000-1.883zm-.285-1.408h.57a.319.319 0 00.319-.318v-5.45a.318.318 0 00-.32-.318h-.57a.317.317 0 00-.317.317v5.451c0 .175.142.318.318.318zm-9.407 5.655l9.628-17.524 9.75 17.524H23.356zm3.623 3.522H12.087V32.56H19.5l-.001-11.699h-7.412v-.734c0-4.106 3.34-7.445 7.446-7.445s7.446 3.34 7.446 7.445v5.74l-5.821 10.595h5.82v2.221zM12.087 21.861h6.412v9.7h-6.412v-9.7zm10.27-11.179v1.175a8.712 8.712 0 00-2.824-.476 8.72 8.72 0 00-2.824.476v-1.175h5.648zM15.602 9.38h7.862V7.518h-7.862V9.38zm17.374 5.57l-4.697 8.55v-3.373c0-3.33-1.874-6.233-4.622-7.709v-1.736h1.108V6.218H14.3v4.464h1.107v1.736c-2.748 1.476-4.622 4.378-4.622 7.71v19.855h17.493v-3.52h16.665L32.976 14.948z"
    }
  );
  return isHovered ? normalHover : normal;
};
export {
  MedicineWarning as default
};
//# sourceMappingURL=MedicineWarning.js.map
